<template>
    <div>
        <table>
            <thead>
                <tr>
                    <th>Title</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in ctn.items" v-bind:key="index">
                    <td :class="{titleDisabled:!enabled}">{{item.name}}</td>
                    <td class="editCol">
                        <button class="flake-btn" @click="edit(index)" v-if="enabled"><i class="material-icons">edit</i></button>
                        <button class="flake-btn" @click="remove(index)" v-if="enabled"><i class="material-icons">delete</i></button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="badd" v-show="!isOpen" @click="isOpen=true" v-if="enabled">
            <i class="material-icons mh_right">add</i>
        </div>
        <div class="add" v-show="isOpen">
            <v-text-field label="Nome" v-model="current.name"></v-text-field>
            <v-text-field label="Cargo" v-model="current.position"></v-text-field>
            <v-text-field label="Comentário" v-model="current.comment"></v-text-field>

            <button class="fluke-btn" @click="add">{{buttomTitle}}</button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.titleDisabled {
    color: rgba(0,0,0,.38);
}
</style>

<script>
import ImageUploader from './../ImageUploader/ImageUploader';

export default {
    props: [ 'disabled' ],
    components: {
        ImageUploader
    },
    data: function() {
        return {
            ctn: {
                items: []
            },
            current: {
                name: '',
                position: '',
                comment: ''
            },
            current_key: 0,
            isOpen: false,
            isEditing: false,
            buttomTitle: 'ADICIONAR',
            enabled: true
        }
    },
    created: function()
    {
        if( this.$props.disabled === true ) this.enabled = false;
        this.ctn.items = (!this.$attrs.value)?[]:this.$attrs.value;
    },
    watch: {
        isEditing: function()
        {
            this.buttomTitle = (this.isEditing===false)?'ADICIONAR':'EDITAR';
        }
    },
    methods: {
        getModuleData(){
            return this.ctn.items;
        },
        add: function()
        {
            if( this.isEditing === false )
            {
                this.ctn.items.push(this.current);
            } 
            else 
            {
                this.isEditing = false;
            }
            this.isOpen = false;
            this.current_key++;
            this.clear();
        },
        clear: function()
        {
            this.current = {
                name: '',
                position: '',
                comment: ''
            };       
        },
        edit: function(index)
        {
            this.isOpen = true;
            this.current = this.ctn.items.filter( (elem,idx) => (index==idx) )[0];
            this.isEditing = index;
        },
        remove: function(index)
        {
            this.ctn.items = this.ctn.items.filter( (elem,idx) => (index!=idx) );
        }
    }
}
</script>

